export default {
  title: "Popular products",
  label: "No popular products selected",
  message: `Popular products are displayed in a horizontal carousel and should represent
  products which are popular or you want your users to view as popular`,
  select_product: "Select popular products",
  selected_products: "Selected products",
  demo_message_product_slider: "This is where the Popular Products that you select, will be displayed."
}
